import React from 'react';
import { Link } from 'react-router-dom';

const Authentication = () => {
    return (
        <div
            style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
            className='card no-border m-3 pt-4 pb-5 d-flex align-items-center'
        >
            <div className='card-body'>
                <h2 className='card-header no-border text-center mb-5'>
                    Authenticator
                </h2>
                <p>
                    1. Install one of the following applications on your mobile
                </p>
                <ul className='mt-3'>
                    <li>FreeOTP</li>
                    <li> Google Authenticator</li>
                </ul>
                <p className='mt-3'>
                    2. Open the application and scan the barcode
                </p>
                <p className='mt-3'>
                    3. Enter the one-time code provided by the application and
                    click Save to finish the setup.
                </p>
                <div className='mt-5 text-center'>
                    <img src='assets/img/code_qr.svg' alt='QR Code' />
                    <Link>
                        <p className='mt-4 fw-bold'>
                            Unable to scan? Click Here
                        </p>
                    </Link>
                </div>
                <div className='mt-4 d-flex gap-4 align-items-center'>
                    <label
                        style={{ width: '15%' }}
                        className='form-label fw-bold'
                    >
                        One-time code
                    </label>
                    <input
                        style={{ width: '85%' }}
                        name='username'
                        type='text'
                        className={`form-control`}
                        placeholder='example@gmail.com'
                    />
                </div>
                <div
                    style={{ maxWidth: '400px' }}
                    className='d-grid gap-2 mt-4 d-flex gap-4 mt-5 mx-auto'
                >
                    <button className='btn btn-splendi-blue fw-bold w-50'>
                        Cancel Changes
                    </button>
                    <button className='btn btn-splendi-blue fw-bold w-50 text-center'>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Authentication;
